import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import t from '../common/localization';
import EditItemView from '../EditItemView';
import { Accordion, AccordionSummary, AccordionDetails, makeStyles, Typography, Paper } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditAttributesView from '../attributes/EditAttributesView';
import Grid from "@material-ui/core/Grid";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'row',
  },
  root: {
          padding: '10px',
          margin: '10px',
          marginLeft: '60px',
  },
  textField: {
           margin: '4px',
           width: '85%',
  },
}));

const DriverPage = () => {
  const classes = useStyles();

  const [item, setItem] = useState();

  return (
    <EditItemView endpoint="drivers" item={item} setItem={setItem}>
      {item &&
        <>
        <div className={classes.root}>
        <Grid container spacing={3}>
        <Grid item xs={8}>
        <Paper elevation={3} >
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">
                {t('sharedRequired')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
             <Grid container spacing={3}>
             <Grid item xs={6}>
              <TextField className={classes.textField}
                margin="normal"
                InputProps={{ disableUnderline: true }}
                value={item.name || ''}
                onChange={event => setItem({...item, name: event.target.value})}
                label={t('sharedName')}
                variant="standard" />
                </Grid>
              <Grid item xs={6}>
              <TextField className={classes.textField}
                margin="normal"
                InputProps={{ disableUnderline: true }}
                value={item.uniqueId || ''}
                onChange={event => setItem({...item, uniqueId: event.target.value})}
                label={t('uniqueId')}
                variant="standard" />
                </Grid>
                </Grid>
            </AccordionDetails>
          </Accordion>
          </Paper>
          </Grid>
          <Grid item xs={4}>
          <Paper elevation={3}>
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">
                {t('sharedAttributes')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <EditAttributesView
                attributes={item.attributes}
                setAttributes={attributes => setItem({...item, attributes})}
                definitions={{}}
                />
            </AccordionDetails>
          </Accordion>
          </Paper>
          </Grid>
          </Grid>
          </div>
        </>
      }
    </EditItemView>
  );
}

export default DriverPage;
